module.exports = require("core-js-pure/features/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/is-iterable.js
// module id = 344
// module chunks = 0